<template>
  <div>
    <div class="pc" :class="['stage_' + stage, ratio > 2.32 ? 'isLand' : '']">
      <div class="right-side">
        <div class="jump-center">
          <a @click="onClickLink('qq')" class="qq"></a>
<!--          <a @click="onClickLink('douyin')" class="douyin"></a>-->
          <a @click="onClickLink('tieba')" class="tieba"></a>
        </div>
<!--        <img src="../assets/gold-qrcode.png" alt="">-->
      </div>
      <div class="logo"></div>
      <div class="slogan"></div>
      <template v-if="stage === 'yuyue'">
        <div class="qrcode-box">
          <img class="qrcode" src="../assets/qrcode_yuyue_real.jpg" alt="">
        </div>
        <div class="btns">
          <a @click="onClickRule"></a>
          <a @click="onClickLink('pay')"></a>
        </div>
      </template>
      <template v-else-if="stage === 'huaner'">
        
          <img class="qrcode" src="../assets/qrcode_huaner.png" alt="">
        
        <div class="btns">
          <a @click="onClickRule"></a>
          <a @click="onClickLink('pay')"></a>
        </div>
      </template>
      <template v-else>
        <div class="download-box">
          <div class="erwema" :style="{ backgroundImage: `url(${downloadWays.img})` }">
            <span class="x-line"></span>
          </div>
          <div class="device_download">
            <a class="android" @click="download('android')"></a>
            <a class="mnq" @click="onClickLink('mumu')"></a>
            <a class="ios" @click="download('ios')"></a>
            <a class="ios-guide" @click="onClickGuide"></a>
          </div>
          <!--        <a class="windows_download" @click="download(downloadWays.pc)"></a>-->
          <a class="pay_center" target="_blank" href="https://ipay.ztgame.com/?game_id=5286"></a>
        </div>
        <div class="sub-btns">
          <div class="rule" @click="onClickRule"></div>
          <!-- <div class="version" @click="onClickVersion"></div> -->
        </div>
      </template>

      <div class="pop-wrapper" v-if="popVisible">
        <div class="pop">
          <div class="close" @click="popVisible = false"></div>
        </div>
      </div>
      <transition name="fade">
        <div class="popup-wrapper" v-show="iosDownloadPopupVisible" @click.self="iosDownloadPopupVisible = false">
          <div class="ios-download-popup popup">
            <img class="popup-title" src="../assets/popup-title_ios_download.png">
            <div class="ctx">
              <canvas class="qrcode-canvas" ref="qrcodeCanvas"></canvas>
<!--              <img class="qrcode" src="../assets/ios-download-qrcode.png" alt="">-->
              <div class="ios-download-guide" @click="onClickGuide"></div>
            </div>
            <div class="close" @click.self="iosDownloadPopupVisible = false"></div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="popup-wrapper" v-if="rulePopupVisible" @click.self="rulePopupVisible = false">
          <div class="rule-popup popup">
            <img class="popup-title" src="../assets/popup-title_rule.png">
            <div class="ctx">
              1）预下载开启时间：<span style="color: #b90000">7月10日 19:00</span><br>
              2）测试类型：付费删档<br>
              3）测试版本：安卓/iOS，推荐mumu模拟器，点击 <a @click="onClickLink('mumu')">下载mumu模拟器</a><br>
              4）设备要求：<br>
              <h2>>>>推荐配置：</h2>
              iOS-A11处理器、内存2G及以上配置设备（iPhone 8p/iPhone X及以上）<br>
              安卓-高通骁龙768G/麒麟820E/天玑900/Exynos 9820及以上、内存6g及以上设备<br>
              <h2>>>>最低配置：</h2>
              iOS-A9处理器、内存2G及以上配置设备（iPhone 6s及以上）<br>
              安卓-高通骁龙460/麒麟710及以上、内存4g及以上设备<br>
              <!-- 5）预约/家族组队备战：<br>
              >>>参与烽启测试预约，即可在开测后获得6888黄金；<br>
              >>>特别注意：本次烽启测试取消预约/随机落州。开测后，主公进游戏可自主选择国家。<br>
              【活动传送门】<a @click="onClickLink('csm')">https://zt-g.cn/a2rtcb5</a><br> -->
              5）充值返利规则：<br>
              1、同一账号在删档测试期间充值的黄金直充和赠送他人的月卡，我们将在下次删档测试重新发送给该账号（包括赠送的黄金、绑定黄金、再次送出的月卡资格）。<br>
              直充黄金<br>
              >>如果玩家的游戏账号在不删档测试中，进行了黄金直充，该账号将在随后每次不删档测试中获得该直充同数量的黄金和绑定黄金。<br>
              >>通过【开服活动】中的【充值返利】，可以查看后续测试返还的直充黄金和绑定黄金返还数量。<br>
              >>公测时的直充黄金返还规则，将在公测时公布。<br>
              赠送月卡<br>
              >>如果玩家的游戏账号在不删档测试中，赠送给其他玩家月卡，该账号将在随后每次不删档测试中获得同规格同数量【月卡赠送道具】。<br>
              >>在背包内使用该道具，可再次选择对象赠送月卡。<br>
              >>账号每次送出的月卡会进行累计，在公测时一次性全额返还给送出的账号。<br>
              2、同一账号在之前删档测试期间累计充值的月卡（不包含系统和其他玩家赠送的月卡），我们将在之后每次删档测试以一定比例叠加返还，不影响玩家当次测试继续充值月卡。<br>
              具体比例如下：<br>
              >>累计充值同档位月卡 1~2张，叠加返还该档位月卡 *1；<br>
              >>累计充值同档位月卡 3~4张，叠加返还该档位月卡 *2；<br>
              >>累计充值同档位月卡 5~9张，叠加返还该档位月卡 *3；<br>
              >>累计充值同档位月卡 10~15张，叠加返还该档位月卡 *4；<br>
              >>累计充值同档位月卡 16张及以上，叠加返还该档位月卡 *5；<br>
              【举例说明】<br>
              假设有一位玩家参与游戏测试，进行如下操作：<br>
              第一次删档测试<br>
              >>本次测试充值 648元月卡 *1，正常获得月卡奖励。<br>
              >>累计充值 648元月卡 *1。第二次删档测试获得 648元返利月卡*1。<br>
              第二次删档测试<br>
              >>获得第一次测试的 648元返利月卡*1。<br>
              >>本次测试充值 648元月卡 *2，正常获得月卡奖励。<br>
              >>前两次测试，累计充值648元月卡 *3。第三次删档测试获得 648元返利月卡*2。<br>
              第三次删档测试<br>
              >>获得前两次测试的 648元返利月卡*2。<br>
              >>本次测试充值 648元月卡*2，正常获得月卡奖励。<br>
              >>前三次测试，累计充值 648元月卡*5，下次测试获得648元返利月卡*3。<br>
              第四次删档测试<br>
              >>获得前三次测试的 648元返利月卡*3。<br>
              >>本次测试充值 648元月卡*5，正常获得月卡奖励。<br>
              >>前四次测试，累计充值 648元月卡*10，下次测试获得648元返利月卡*4。<br>
              第五次删档测试<br>
              >>获得前四次测试的 648元返利月卡*4。<br>
              >>未充值648元月卡。<br>
              游戏公测<br>
              >>游戏将返还前五次删档测试，累计充值的 648元月卡*10。具体返还规则将在公测时公布。
            </div>
            <div class="close" @click.self="rulePopupVisible = false"></div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="popup-wrapper" v-if="versionPopupVisible" @click.self="versionPopupVisible = false">
          <div class="version-popup popup">
            <img class="popup-title" src="../assets/popup-title_version.png">
            <div class="ctx">
              <img style="width: 100%" src="../assets/version-content.jpg" alt="">
            </div>
            <div class="close" @click.self="versionPopupVisible = false"></div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="popup-wrapper" v-if="iosGuideVisible" @click.self="iosGuideVisible = false">
          <div class="guide-popup popup">
            <img class="popup-title" src="../assets/popup-title_guide.png">
            <div class="ctx">
              <img src="../assets/ios-guide.png" alt="" class="guide">
            </div>
            <div class="close" @click.self="iosGuideVisible = false"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import 'animate.min.css'
import Api from "@/api/api";
import { getParameterByName,radiopc } from "@/tools/utils";
import QRCode from 'qrcode'

export default {
  data() {
    return {
      isLand: false,
      isShow: false,
      downloadWays: {},
      popVisible: false,
      rulePopupVisible: false,
      versionPopupVisible: false,
      iosGuideVisible: false,
      iosDownloadPopupVisible: false,
      ztmtag: '',
      iosDownloadQRCode: '',
      stage: 'download',
      ratio: radiopc()
    }
  },
  methods: {
    onClickRule() {
      this.rulePopupVisible = true
      window._paq && window._paq.push(['trackEvent', '官网', '点击', '测试须知', 'pc'])
    },
    onClickVersion() {
      this.versionPopupVisible = true
      window._paq && window._paq.push(['trackEvent', '官网', '点击','版本内容', 'pc'])
    },
    onClickLink(type) {
      let url = ''
      let param = ''
      switch (type) {
        case 'pay':
          url = 'https://ipay.ztgame.com/?game_id=5286'
            param = '支付中心'
          break
        case 'qq':
            url = 'https://qm.qq.com/q/qlodnL2uiI'
            param = 'qq'
          break
        case 'douyin':
            url = 'https://www.douyin.com/user/MS4wLjABAAAAzt0UIK7aKRrqdcuBQhuKAChacazCsX1Oc4UuWU4ncBQ?from_tab_name=main'
            param = '抖音'
          break
        case 'tieba':
            url = 'https://tieba.baidu.com/f?fr=wwwt&ie=utf-8&dyTabStr=MCwzLDEsMiwxMyw3LDYsNSwxMiw5&kw=%E4%BA%94%E5%8D%83%E5%B9%B4'
            param = '贴吧'
          break
        case 'ldmnq': // 雷电模拟器
            url = 'https://www.ldmnq.com/'
            param = '雷电模拟器'
          break
        case 'mumu': // mumu模拟器
            url = 'https://mumu.163.com'
            param = 'mumu模拟器'
          break
        case 'csm': // 预约传送门
            url = 'https://zt-g.cn/a2rtcm6'
            param = '传送门'
          break
      }
      window._paq && window._paq.push(['trackEvent', '官网', '点击', param, 'pc'])
      window.open(url)
    },
    checkOrientation() {
      let ww = window.innerWidth
      let wh = window.innerHeight
      if (ww > wh) {
        this.isLand = true
      } else {
        this.isLand = false
      }
    },
    // change() {
    //   var footer = document.querySelector('.footer')
    //   var a = document.querySelector('.footer #bottom .botps30 a')
    //   var p = document.querySelectorAll('.footer #bottom .botp3')
    //   var p2 = document.querySelector('.footer #bottom .botps30')
    //   var p3 = document.querySelector('.footer #bottom .botp2')
    //   var a1 = document.querySelector('.footer #bottom .botp1>a:nth-child(6)')
    //   var p1 = document.querySelector('.footer #bottom .botp1')
    //   var a2 = document.querySelector('.footer #bottom .botp1 .fwico1')
    //   var a3 = document.querySelector('.footer #bottom .botp1 .fwico2')
    //   var a4 = document.querySelector('.footer #bottom .botp1 .fwico3')
    //   var a5 = document.querySelector('.footer #bottom .botp1 .fwico4')
    //   footer.style = "height:114px"
    //   a.href = "https://www.ztgame.com/privacy.html"
    //   p[0].innerHTML = "互联网出版许可证：(属)网出证(沪)字第026号  增值电信业务经营许可证：沪B2-20050107  ISBN：978-7-89988-481-2"
    //   p2.innerHTML = "健康游戏忠告：抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防受骗上当，适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活。" +
    //       `<a href="https://www.ztgame.com/privacy.html" target="_blank">隐私协议</a>` +
    //       `<a href="//www.ztgame.com/html/clause.html" target="_blank">客户权限</a>`
    //   p3.innerHTML = ''
    //   a1.innerText = "适龄提示：本游戏适合18岁以上的玩家进入"
    //   console.log(p[1].innerHTML)
    //   p[1].innerHTML = ""
    //   console.log(p1.innerHTML)
    //   p1.innerHTML =
    //       `<a target="_blank" href="http://www.ga-me.com/cn/about_us.php">关于巨人</a>` + " | " +
    //       `<a target="_blank" href="http://www.ztgame.com/html/clause.html">服务条款</a>` + " | " +
    //       `<a target="_blank" href="http://www.ztgame.com/swhz.html">商务中心</a>` + " | " +
    //       `<a target="_blank" href="http://www.ga-me.com/cn/contact_details.php">联系我们</a>` + " | " +
    //       `<a href="http://jrkf.ztgame.com/index.php?g=front&amp;m=index&amp;a=article&amp;aid=5365" target="_blank">家长监护工程</a>` + " | " +
    //       `<a>适龄提示：本游戏适合18岁以上的玩家进入</a>` +
    //       `<a href = "http://sh.cyberpolice.cn/infoCategoryListAction.do?act=initjpg" target = "_blank" class="fwico1" style="position:absolute;top:-50%; left:103%;">&nbsp;</a> ` +
    //       `<a href = "http://www.zx110.org/" target = "_blank" class="fwico2" style="position:absolute; top:-50%; left:110%;">&nbsp;</a> ` +
    //       `<a href = "http://www.shjbzx.cn/" target = "_blank" class="fwico3" style="position:absolute; top:-50%; left:117%;">&nbsp;</a> ` +
    //       `<a href = "http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&amp;serial=9031000020170703190538000001896554-SAIC_SHOW_310000-20171108192223631725&amp;signData=MEUCIQDQnAyL5DFlHdA/KX8XR/MMqfZIysPfbnQOCtTQYIV2tQIgWDLdelQgucUz/pTfount98xrUv5R7SOYZlc3rq8ImRE" target = "_blank" class="fwico4" style="position:absolute; top:-50%; left:124%;">&nbsp;</a> ` +
    //       `<a href = "http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/gameNetTag/4028c08c5f137bbf015f2e11a6400d13" target = "_blank" class="fwico5" style="position:absolute; top:-50%; left:131%;">&nbsp;</a>`
    // },
    download(type) {
      if (type === 'ios') {
        this.iosDownloadPopupVisible = true
        window._paq && window._paq.push(['trackEvent', '官网', '下载', 'PC端ios下载', 'pc'])
        return
      }
      if (type === 'android') {
        window._paq && window._paq.push(['trackEvent', '官网', '下载', 'PC端android下载', 'pc'])
        window.open('/download/android.html' + (this.ztmtag ? '?ztmtag=' + this.ztmtag : ''))
        return
      }
    },
    onClickGuide() {
      this.iosGuideVisible = true
      window._paq && window._paq.push(['trackEvent', '官网', '点击', 'ios指南', 'pc'])
    }
  },
  async mounted() {
    this.ztmtag = getParameterByName('ztmtag') || ''
    // this.change()
    const res = await Api.getDownloadWays()
    if (this.ztmtag) {
      this.downloadWays = res[this.ztmtag] ? res[this.ztmtag] : res.giant
    } else {
      this.downloadWays = res.giant
    }
    this.iosDownloadQRCode = 'https://wqn.ztgame.com/download/ios.html' + (this.ztmtag ? '?ztmtag=' + this.ztmtag : '')
    QRCode.toCanvas(this.$refs.qrcodeCanvas, this.iosDownloadQRCode, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',  // 二维码颜色
        light: '#ffffff' // 背景色
      }
    })
  }
}
</script>
<style lang="stylus" scoped>
body
.pc {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background url('../assets/bgb.jpg') no-repeat center center;
  background-size: cover;
  font-size: .22rem;
  color #000
  &.isLand {
    background url('../assets/bgb-k.jpg') no-repeat center top;
  }
}

.right-side {
  top: .2rem;
  right: .2rem
  position: absolute;
  .jump-center {
    background url('../assets/jump-center.png') no-repeat center;
    background-size 100% 100%
    width 1.65rem
    height 2.45rem
    display: flex;
    box-sizing border-box
    justify-content space-between
    padding 0 .34rem
    a {
      display block
      width .42rem
      height .42rem
      margin-top 0.07rem
      box-sizing border-box
      border-radius .42rem
      cursor pointer
    }
  }
  > img {
    width 100%
    height auto
    margin-top .2rem
  }
}
.logo {
  background url('../assets/logo.png') no-repeat center;
  background-size cover;
  width: 2.81rem
  height 1.22rem
  position: absolute;
  top: .2rem;
  left: .3rem
  animation slideInDown 0.5s ease-in-out forwards
}

@keyframes slideInDown {
  from {
    transform: translateY(-100%);
    visibility: visible;
  }

  to {
    transform: translateY(0);
  }
}

@keyframes shark-wrap {
  to {
    transform: translateX(70%);
  }
}


.slogan {
  background-repeat no-repeat
  background-position center
  background-size 100% 100%
  position: absolute;
  left 50%;
  top 50%;
  margin-top: -4.9rem;
  animation slideInDown 0.8s ease-in-out 0.2s
  &::after {
    content: '';
    position: absolute;
    inset: -20%;
    background: linear-gradient(40deg, rgba(255,255,255,0) 40%, rgba(255, 255, 198, 0.8), rgba(124,219,201,0) 60%);
    animation: shark-wrap 2s infinite;
    transform: translateX(-70%);
  }
}
.qrcode-box {
  width 2.38rem
  height 2.78rem
  position: absolute;
  left: 50%;
  top: 50%;
  transform translate(-50%, 0.4rem);
  background: url('../assets/qrcode_yuyue.png') no-repeat center;
  background-size: cover;
}
.qrcode {
  position: absolute;
  border-radius: 0.1rem;
  width 2.25rem
  left .08rem
  // height 1.85rem
  bottom 0
}
.stage_yuyue {
  .slogan {
    background-image url("../assets/slogan_yuyue.png")
    width 9.15rem
    margin-left: -4.57rem;
    height 4.76rem
    -webkit-mask: url('../assets/slogan_yuyue.png') 0 0/100%;
  }
}
.stage_huaner {
  .slogan {
    background-image url("../assets/slogan_huaner.png")
    -webkit-mask: url('../assets/slogan_huaner.png') 0 0/100%;
    width 9.15rem
    margin-left: -4.57rem;
    height 4.77rem
  }
  .qrcode {
    left calc(50% - 1.175rem);
    bottom 3rem;
  }
}
.stage_download {
  .slogan {
    background-image url("../assets/slogan_huaner.png")
    -webkit-mask: url('../assets/slogan_huaner.png') 0 0/100%;
    width 9.15rem
    height 4.77rem
    margin-left: -4.57rem;
    margin-top: -4rem;
  }
  .qrcode {
    transform translate(-50%, 0.2rem);
  }
}

.btns {
  position: absolute;
  left: 50%;
  top: 50%;
  transform translate(-50%, 4.4rem);
  display flex;
  > a {
    background url('../assets/btns.png') no-repeat 0 0;
    background-size 5.58rem 1.2rem
    width 2.68rem
    height 1.2rem
    cursor pointer
    &:hover {
      filter: brightness(1.1);
    }
    &:first-child {
      background-position-x 0
      margin-right .2rem
    }
    &:last-child {
      background-position-x right
    }
  }
}
.download-box {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 2rem;
  width 8.63rem
  height 2.5rem
  background: red;
  margin: 0 auto;
  z-index: 10;
  background: url('../assets/download-bg.png') no-repeat center;
  background-size: cover;
  display: flex;
  align-items: center;

  .erwema {
    position: relative;
    width: 1.36rem;
    height: 1.36rem;
    background-size: cover;
    margin-left: 1.16rem;

    .x-line {
      position: absolute;
      width: 1.36rem;
      height: .1rem;
      left 0
      background: url('../assets/x_line.png') no-repeat center;
      background-size: cover;
      animation: laihh 1s infinite linear alternate;
    }

    @keyframes laihh {
      0% {
        top: 10%;
      }

      100% {
        top: 80%;
      }
    }
  }

  .device_download {
    width: 3.66rem;
    margin: 0 .14rem;
    display: flex;
    justify-content space-between
    flex-wrap wrap
    a {
      display: block;
      width: 2.15rem;
      height: .66rem;
      background: url('../assets/download-btns.png') no-repeat;
      background-size: 5.17rem 1.4rem;
      margin-bottom: .1rem;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        filter: brightness(1.1);
      }
    }
    .android {
      background-position 0 0
    }
    .mnq {
      width 1.37rem
      background-position -2.29rem 0
    }
    .ios {
      margin-bottom: 0;
      background-position 0 bottom
    }

    .ios-guide {
      width 1.37rem
      margin-bottom: 0;
      background-position -2.29rem bottom
    }

    .mnq .ios-guide {
      width 1.37rem
    }
  }

  .windows_download {
    width: 114px;
    height: 116px;
    background: url('../assets/download-btns.png') no-repeat center;
    background-size: 304px 116px;
    background-position-x: right;
    background-position-y: top;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      filter: brightness(1.1);
    }
  }
  .pay_center {
    width 1.37rem
    height 1.4rem;
    background url('../assets/download-btns.png') no-repeat right 0;
    background-size: 5.17rem 1.4rem;
    cursor: pointer;
    &:hover {
      filter: brightness(1.1);
    }
  }
}
.sub-btns {
  position absolute
  bottom 1.2rem
  left 50%
  transform: translate(-50%);
  display flex
  justify-content space-between
  width 1.36rem
  height .6rem
  background-image url("../assets/sub-btns.png")
  background-size 1.36rem .6rem
  div {
    width 1.36rem
    height .6rem
    cursor pointer
    background-image url("../assets/sub-btns.png")
    background-size 1.36rem .6rem
    background-repeat no-repeat
    bacground-position right 0
    animation fadeBtn 1s linear infinite alternate
    &:hover {
      filter: brightness(1.1);
    }
  }
}

@keyframes fadeBtn {
  0% {
    opacity 1
  }
  100% {
    opacity 0
  }
}

.pop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;

  .pop {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width 4.41rem
    height 3rem
    background: url('../assets/jqqd.png') no-repeat center;
    background-size: cover;
    .close {
      position: absolute;
      bottom: -.8rem;
      left: 50%;
      transform: translateX(-50%);
      background url('../assets/close.png') no-repeat center;
      background-size: cover;
      width .56rem
      height .57rem;
      cursor: pointer;
    }
  }
}
.qrcode-canvas {
  width 70% !important
  height auto !important
}
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  .popup {
    box-sizing border-box
    position absolute
    width 6.11rem
    height 7.82rem
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background url("../assets/popup-bg.png")
    background-size 100% 100%
    padding  1.2rem .4rem .4rem
    .popup-title {
      position absolute
      left 50%
      top .4rem
      transform translateX(-50%)
      height .44rem
      width auto
    }
    .ctx {
      width 100%
      height 100%
      overflow-y auto
      text-align: left;
      line-height: 1.8;
      .emphsis {
        background-color rgba(255,246,122,0.8)
      }
      h2 {
        font-size: 0.22rem;
        margin: 0.04rem 0;
      }
      a {
        cursor: pointer;
        color: #007aff;
        text-decoration: underline;
      }
    }
  }

  .rule-popup {
    .ctx {
      text-align left
      line-height 1.8
      h2 {
        font-size: .22rem;
        margin .04rem 0
      }
      a {
        cursor pointer
        color #007aff
        text-decoration underline
      }
    }
  }
  .version-popup {
    padding  1.2rem .3rem .3rem
  }
  .guide-popup {
    .ctx {
      img {
        width 100%
        height auto
      }
    }
  }
  .ios-download-popup  {
    .ctx {
      display flex
      flex-direction column
      align-items center
      img {
        width 70%
        margin-top .4rem
      }
      .ios-download-guide {
        width 2.7rem
        height .88rem
        background url('../assets/ios-guide-btn.png') no-repeat center;
        background-size 100% 100%;
        margin-top .4rem
        cursor pointer
        &:hover {
          filter: brightness(1.1);
        }
      }
    }
  }
}
.popup .close {
  cursor pointer
  width .56rem
  height .57rem
  background url(../assets/close.png) no-repeat center;
  background-size 100% 100%;
  position absolute
  left 50%
  bottom -1rem
  transform translateX(-50%)
  transition: transform 0.8s ease-in-out;
  &:hover {
    filter: brightness(1.2);
    transform: translateX(-50%) rotate(360deg);
  }
}
</style>